<template>
  <div class="payment-page">
    <div class="payment-info">
      <img src="/assets/images/delete-warning.svg" alt="" class="image"/>
      <template v-if="paymentType === 'add-card'">
        <h2 class="title">{{ $t('paymentFail.cardAddFailTitle') }}</h2>
      </template>
      <template v-else>
        <h2 class="title">{{ $t('paymentFail.failTitle') }}</h2>
        <p class="description"></p>
      </template>
      <base-link variant="primary-button" :href="backLink">
        {{ $t('paymentFail.backButton') }}
      </base-link>
    </div>
  </div>
</template>

<script>
import { parseQueryString } from '@/utils/queryParser'
import { backLinks } from '@/config/paymentTypeLinks'
import { lsGet } from '@/utils/localStorageController'

export default {
  name: 'page-payment-fail',
  data () {
    return {
      paymentType: null
    }
  },
  computed: {
    backLink () {
      if (this.paymentType === 'add-card' && lsGet('sc_standingOrderAddCard')) {
        return backLinks['add-card-so']
      }
      if (lsGet('sc_deposit_topup')) {
        return backLinks['digital-services']
      }
      return backLinks[this.paymentType] || backLinks.default
    }
  },
  mounted () {
    const query = parseQueryString()
    if (query) {
      this.paymentType = query.type || null
    }
  }
}
</script>

<style scoped lang="scss" src="./styles/payment-page.scss"></style>
